import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AppRouter from "@/router";

export default function App() {
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, [location.pathname]);

  if (!ready) return null;

  return <AppRouter />;
}
